'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /**
                     * From keppelen/react-facebook-login
                     */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _decodeParam = require('./decodeParam');

var _decodeParam2 = _interopRequireDefault(_decodeParam);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookLogin = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(FacebookLogin, _React$Component);

  function FacebookLogin() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FacebookLogin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacebookLogin.__proto__ || (0, _getPrototypeOf2.default)(FacebookLogin)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSdkLoaded: false,
      isProcessing: false
    }, _this.isRedirectedFromFb = function () {
      var params = window.location.search;
      return (0, _decodeParam2.default)(params, 'code') || (0, _decodeParam2.default)(params, 'granted_scopes');
    }, _this.responseApi = function (authResponse) {
      window.FB.api('/me', { locale: _this.props.language, fields: _this.props.fields }, function (me) {
        (0, _assign2.default)(me, authResponse);
        _this.props.callback(me);
      });
    }, _this.checkLoginState = function (response) {
      _this.setStateIfMounted({ isProcessing: false });
      if (response.authResponse) {
        _this.responseApi(response.authResponse);
      } else if (_this.props.onFailure) {
        _this.props.onFailure({ status: response.status });
      } else {
        _this.props.callback({ status: response.status });
      }
    }, _this.checkLoginAfterRefresh = function (response) {
      if (response.status === 'connected') {
        _this.checkLoginState(response);
      } else {
        window.FB.login(function (loginResponse) {
          return _this.checkLoginState(loginResponse);
        }, true);
      }
    }, _this.click = function (event) {
      if (!_this.state.isSdkLoaded || _this.state.isProcessing || _this.props.isDisabled) {
        return;
      }
      _this.setState({ isProcessing: true });
      var _this$props = _this.props,
          scope = _this$props.scope,
          appId = _this$props.appId,
          onClick = _this$props.onClick,
          returnScopes = _this$props.returnScopes,
          responseType = _this$props.responseType,
          redirectUri = _this$props.redirectUri,
          authType = _this$props.authType,
          state = _this$props.state;


      if (typeof onClick === 'function') {
        onClick(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      var params = {
        client_id: appId,
        redirect_uri: redirectUri,
        state: state,
        return_scopes: returnScopes,
        scope: scope,
        response_type: responseType,
        auth_type: authType
      };

      if (!window.FB) {
        if (_this.props.onFailure) {
          _this.props.onFailure({ status: 'facebookNotLoaded' });
        }

        return;
      }

      window.FB.login(_this.checkLoginState, { scope: scope, return_scopes: returnScopes, auth_type: params.auth_type });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FacebookLogin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      if (document.getElementById('facebook-jssdk')) {
        this.sdkLoaded();
        return;
      }
      this.setFbAsyncInit();
      this.loadSdkAsynchronously();
      var fbRoot = document.getElementById('fb-root');
      if (!fbRoot) {
        fbRoot = document.createElement('div');
        fbRoot.id = 'fb-root';
        document.body.appendChild(fbRoot);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.isSdkLoaded && nextProps.autoLoad && !this.props.autoLoad) {
        window.FB.getLoginStatus(this.checkLoginAfterRefresh);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'setStateIfMounted',
    value: function setStateIfMounted(state) {
      if (this._isMounted) {
        this.setState(state);
      }
    }
  }, {
    key: 'setFbAsyncInit',
    value: function setFbAsyncInit() {
      var _this2 = this;

      var _props = this.props,
          appId = _props.appId,
          xfbml = _props.xfbml,
          cookie = _props.cookie,
          version = _props.version,
          autoLoad = _props.autoLoad;

      window.fbAsyncInit = function () {
        window.FB.init({
          version: 'v' + version,
          appId: appId,
          xfbml: xfbml,
          cookie: cookie
        });
        _this2.setStateIfMounted({ isSdkLoaded: true });
        if (autoLoad || _this2.isRedirectedFromFb()) {
          window.FB.getLoginStatus(_this2.checkLoginAfterRefresh);
        }
      };
    }
  }, {
    key: 'sdkLoaded',
    value: function sdkLoaded() {
      this.setState({ isSdkLoaded: true });
    }
  }, {
    key: 'loadSdkAsynchronously',
    value: function loadSdkAsynchronously() {
      var language = this.props.language;

      (function (document, source, id) {
        var element = document.getElementsByTagName(source)[0];
        var fjs = element;
        var js = element;
        if (document.getElementById(id)) {
          return;
        }
        js = document.createElement(source);js.id = id;
        js.src = 'https://connect.facebook.net/' + language + '/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
  }, {
    key: 'render',
    value: function render() {
      var render = this.props.render;


      if (!render) {
        throw new Error('ReactFacebookLogin requires a render prop to render');
      }

      var propsForRender = {
        onClick: this.click,
        isDisabled: !!this.props.isDisabled,
        isProcessing: this.state.isProcessing,
        isSdkLoaded: this.state.isSdkLoaded
      };
      return this.props.render(propsForRender);
    }
  }]);
  return FacebookLogin;
}(_react2.default.Component), _class.propTypes = {
  isDisabled: _react.PropTypes.bool,
  callback: _react.PropTypes.func.isRequired,
  appId: _react.PropTypes.string.isRequired,
  xfbml: _react.PropTypes.bool,
  cookie: _react.PropTypes.bool,
  authType: _react.PropTypes.string,
  scope: _react.PropTypes.string,
  state: _react.PropTypes.string,
  responseType: _react.PropTypes.string,
  returnScopes: _react.PropTypes.bool,
  redirectUri: _react.PropTypes.string,
  autoLoad: _react.PropTypes.bool,
  fields: _react.PropTypes.string,
  version: _react.PropTypes.string,
  language: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  onFailure: _react.PropTypes.func,
  render: _react.PropTypes.func.isRequired
}, _class.defaultProps = {
  redirectUri: typeof window !== 'undefined' ? window.location.href : '/',
  scope: 'public_profile,email',
  returnScopes: false,
  xfbml: false,
  cookie: false,
  authType: '',
  fields: 'name',
  version: '10.0',
  language: 'en_US',
  onFailure: null,
  state: 'facebookdirect',
  responseType: 'code'
}, _temp2);
exports.default = FacebookLogin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FacebookLoginButton/FacebookLogin/FacebookLogin.js
// module id = 1951
// module chunks = 0